export enum htmlElements {
  LINK = 'a',
}
